/* eslint-disable react/require-default-props */
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Card, Spinner } from 'react-bootstrap';

import { faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { QUESTION_FILTER_TYPE } from '../../../../constants/common';
import SectionQuestion from '../SectionQuestion';
import SectionInfoCard from '../SectionInfoCard';
import './styles.css';

const SectionQuestions = ({
  sectionName,
  sectionCode,
  surveyQuestions,
  visualizations,
  busy,
  isEditSection,
  refreshToken,
  onEditSectionClick,
  onSelectQuestion,
  onLoadQuestion,
  onQuestionRefreshed,
}) => {
  const [isOpen, setIsOpen] = useState(isEditSection);
  const [questions, setQuestions] = useState([]);

  useEffect(() => {
    setIsOpen(isEditSection);
  }, [isEditSection, setIsOpen]);

  // Hide related questions and attribute filters (shown under Other Filters)
  // from section questions.
  useEffect(() => {
    const questionList = (surveyQuestions?.questions || []).filter(
      (question) => !!question.code && question.filterType !== QUESTION_FILTER_TYPE.ATTRIBUTE
    );
    setQuestions(questionList);
  }, [surveyQuestions]);

  return (
    <>
      {busy && (
        <div className="loading-container">
          <div className="content">
            <Spinner animation="border" role="status" />
            Updating preview with your changes
          </div>
        </div>
      )}
      {/* While busy the card is hidden with CSS, NOT unmounted: the expanded
          SectionQuestion must stay alive to run the post-save reload and
          report back (onQuestionRefreshed) so the loading state can clear. */}
      <Card className={`survey-info-card bg-gray${busy ? ' d-none' : ''}`}>
        <Card.Header className="survey-info-card-header" onClick={() => setIsOpen(!isOpen)}>
          {sectionName}
          <span>
            {isOpen && <FontAwesomeIcon size="lg" className="ml-1 mr-5" icon={faSortDown} />}
            {!isOpen && <FontAwesomeIcon size="lg" className="ml-1 mr-5" icon={faSortUp} />}
          </span>
        </Card.Header>
        {isOpen && (
          <SectionInfoCard
            sectionName={sectionName}
            sectionCode={sectionCode}
            onEditClick={onEditSectionClick}
          />
        )}
        {questions.map((question, index) => (
          <SectionQuestion
            key={question.id}
            index={index}
            question={question}
            sectionId={surveyQuestions.id}
            visualizations={visualizations}
            refreshToken={refreshToken}
            onSelectedQuestion={onSelectQuestion}
            onLoadQuestion={onLoadQuestion}
            onQuestionRefreshed={onQuestionRefreshed}
          />
        ))}
      </Card>
    </>
  );
};

SectionQuestions.propTypes = {
  sectionName: PropTypes.string.isRequired,
  sectionCode: PropTypes.string,
  surveyQuestions: PropTypes.instanceOf(Object),
  visualizations: PropTypes.instanceOf(Object),
  busy: PropTypes.bool,
  isEditSection: PropTypes.bool.isRequired,
  refreshToken: PropTypes.number,
  onEditSectionClick: PropTypes.func.isRequired,
  onSelectQuestion: PropTypes.func.isRequired,
  onLoadQuestion: PropTypes.func.isRequired,
  onQuestionRefreshed: PropTypes.func,
};

export default SectionQuestions;
